import * as React from "react";
import { Divider, Typography } from "antd";
import Report1ParamsBox from "../../components/report/report1Components/Report1ParamsBox";
import { IReport1Presenter } from "../../../presenter/report/Report1Presenter";
import Report1Preview from "../../components/report/report1Components/Report1Preview";
import PDFExportReport1 from "../../components/report/report1Components/PDFExportReport1";

export interface Props {}

export interface State extends IReport1Presenter {}

export default class Report1Page extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      report1ReportingPeriodList,
      onChangeReportingPeriod,
      report1CurrentReportingPeriod,
      translate,
      getPDFReport1,
      report1,
      report1CurrentApplicant,
      onChangeApplicant,
      report1CurrentFormType,
      onChangeFormType,
      onChangeFormVersion,
      report1CurrentFormVersion,
      formVersionList,
      onChangeIncludePublic,
      report1IncludePublic,
      onApplicantSearch,
    } = this.state;

    return (
      <div className={"report-container"}>
        <Report1ParamsBox
          currentReportingPeriod={report1CurrentReportingPeriod}
          reportingPeriodList={report1ReportingPeriodList}
          onChangeReportingPeriod={onChangeReportingPeriod}
          currentApplicant={report1CurrentApplicant}
          applicants={this.state.report1ApplicantList}
          onChangeApplicant={onChangeApplicant}
          currentFormType={report1CurrentFormType}
          formTypes={this.state.formTypeList}
          onChangeFormType={onChangeFormType}
          getPDFReport={getPDFReport1}
          translate={translate}
          loading={this.state.loaders.report1Loader}
          title={translate("reports.params.reporting_period")}
          onChangeFormVersion={onChangeFormVersion}
          currentFormVersion={report1CurrentFormVersion}
          formVersionList={formVersionList}
          onChangeIncludePublic={onChangeIncludePublic}
          includePublic={report1IncludePublic}
          onApplicantSearch={onApplicantSearch}
        />
        <Divider type={"vertical"} style={{ height: "100%" }} />
        {report1 && (
          <div style={{ width: "75%", paddingLeft: 10 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <Typography.Title style={{ fontSize: 14 }}>
                {translate("reports.review_report")}
              </Typography.Title>
              <div>
                {!this.state.loaders.report1Loader && (
                  <PDFExportReport1
                    applicant={this.state.report1CurrentApplicant}
                    translate={translate}
                    data={this.state.report1}
                    title={translate("reports.report_1")}
                    subtitle={report1CurrentReportingPeriod?.name}
                    fileName={`${translate("reports.report_1")}.pdf`}
                    loader={this.state.loaders.report1Loader}
                    formVersion={report1CurrentFormVersion}
                    formType={report1CurrentFormType}
                    reportingPeriodId={report1CurrentReportingPeriod?.id}
                    reportingPeriodFormTypeId={report1CurrentFormType?.id}
                    isPortal={report1IncludePublic}
                  />
                )}
              </div>
            </div>
            <Divider type={"horizontal"} />
            <Report1Preview
              translate={translate}
              data={report1}
              title={report1CurrentReportingPeriod?.name}
              subtitle={translate("reports.report_1")}
              loader={this.state.loaders.report1Loader}
              isPortal={report1IncludePublic}
            />
          </div>
        )}
      </div>
    );
  }
}
